/* eslint-disable no-unused-vars */
import { CREATE, RETRIEVE, UPDATE, DELETE } from "./actionTypes";

const initialState = [];

function getNewID(state) {
  if (state.length > 0) {
    return (
      state.reduce(
        (currentMax, object) => Math.max(currentMax, object.id),
        -1
      ) + 1
    );
  }
  return 0;
}

export default function booksReducer(state = initialState, action) {
  let duplicateState = [...state];
  switch (action.type) {
    case CREATE:
      return [
        ...state,
        {
          id: getNewID(state),
          author: action.payload.author,
          featured: action.payload.featured,
          name: action.payload.name,
          price: action.payload.price,
          rating: action.payload.rating,
          thumbnail: action.payload.thumbnail,
        },
      ];

    case RETRIEVE:
      return [...action.payload];

    case UPDATE:
      let selectedBook = duplicateState.findIndex(
        (book) => book.id === action.payload.id
      );
      duplicateState[selectedBook] = action.payload;
      return duplicateState;

    case DELETE:
      duplicateState = state.filter((book) => book.id !== action.payload);
      return duplicateState;
    default:
      return state;
  }
}
